import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const CoachMag: Site = {
  id: 'coachmag',
  logo: 'svg/coach.svg',
  label: 'Coach',
  analyticsName: 'coachmag',
  hostname: 'coachweb.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, .content a`,
};
